import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseReviewLearning } from '@/api/responses/reviewLearnings'

export namespace ReviewLearningsApi {
  /**
   * 演習履歴取得(復習BOX)
   *
   * @param learningId 履歴ID
   * @returns 演習履歴
   */
  export async function getReviewLearning(learningId: number): Promise<ApiResponseReviewLearning> {
    return await ApiBase.get(`/reviewLearnings/${learningId}`)
  }
}
